const checklistServiceButton = {
  create: 'CRIAR SERVIÇO',
  scroll: 'IR PARA A PERGUNTA NÃO RESPONDIDA',
  needAction: 'IR PARA A PERGUNTA SEM AÇÃO',
  needSignatures: 'NECESSÁRIO ADICIONAR ASSINATURA',
};

export default checklistServiceButton;